import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import ErrorBoundary from "@jkast90/kast-common/error-boundary";
import { buttonClass } from "@jkast90/kast-common/ui";
import SignUp from "./auth/pages/SignUp";
import SignIn from "./auth/pages/SignIn";
import CheckEmail from "./auth/pages/CheckEmail";
import Confirmed from "./auth/pages/Confirmed";
import buttonStyles from "./auth/pages/SignUp.module.css";

// Keyed on the route's section (first path segment), so moving to another
// page clears a crash without remounting on changes deeper in the path.
function AppRoutes() {
  const location = useLocation();
  return (
    <ErrorBoundary
      key={location.pathname.split("/")[1]}
      buttonClassName={buttonClass({ variant: "primary", className: buttonStyles.button })}
    >
      <Routes>
        <Route path="/" element={<SignIn />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/signin" element={<SignIn />} />
        <Route path="/check-email" element={<CheckEmail />} />
        <Route path="/confirmed" element={<Confirmed />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </ErrorBoundary>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  );
}
